module.exports = __webpack_public_path__ + "static/media/gallery-2-1.bec99c55.png";